import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { deleteApi } from 'views/services/api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

const DeleteComplaint = ({ open, handleClose, id }) => {
  const params = useParams();
  const complaintId = params.id;

  const navigate = useNavigate();
  //handle delete function-------------
  const handleDelete = async () => {
    try {
      let result = await deleteApi(`api/complaint/delete/`, id || complaintId);
      if (result) {
        toast.success('Complaint Deleted Successfully');
        handleClose();
        setTimeout(() => {
          navigate('/dashboard/complaint');
        }, 100);
      } else {
        toast.error('Cannot delete Complaint');
      }
    } catch (error) {
      console.log(error);
      toast.error('Cannot delete Complaint');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Complaint</DialogTitle>
      <DialogContent>
        <p>Are you sure you want to delete this Complaint?</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteComplaint.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  id: PropTypes.string
};

export default DeleteComplaint;
